import { useState } from "react";
import FilterBtn from "../../../../Universal/FilterBtn.component";
import ToggleClickButton from "../../../../Universal/ToggleClickButton.component";
import StudentsStore from "../../../../../store/Academic/Students.store";
const StudentProfileHeaderCustomElements = ({ changePage }) => {
  const [filteredData, setFilteredData] = useState([]);
  const { currentPage } = StudentsStore();
  return (
    <div
      className="flex-row align-center justify-start g-05"
      style={{ height: "2.3rem" }}
    >
      <FilterBtn
        setFilteredData={setFilteredData}
        filteredData={filteredData}
        filterArray={["2019", "2020", "2021", "2022", "2023", "2024", "2025"]}
        btnTitle="Filter"
      />
      <ToggleClickButton
        label="Attendance report"
        onclick={({ inputVal }) =>
          changePage(inputVal ? "attendance" : "overview")
        }
        btnVal={currentPage === "attendance" ? true : false}
      />
      <ToggleClickButton
        label="Performance report"
        onclick={({ inputVal }) =>
          changePage(inputVal ? "performance" : "overview")
        }
        btnVal={currentPage === "performance" ? true : false}
      />
      <ToggleClickButton
        label="Report history"
        onclick={({ inputVal }) => changePage(inputVal ? "report" : "overview")}
        btnVal={currentPage === "report" ? true : false}
      />
    </div>
  );
};

export default StudentProfileHeaderCustomElements;
